module.exports = __webpack_public_path__ + "img/bg1.d4c23804.png";